
import { AuthProvider } from "./AuthContext";
import { useState, useEffect } from "react";
import { HashRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Header from './components/Header';
import Footer from './components/Footer';

import Login from './components/Login';
import Enshrine from './components/Enshrine';
import EnshrineAdd from "./components/EnshrineAdd"; // EnshrineAdd 페이지 추가
import EnshrineEdit from "./components/EnshrineEdit"; // EnshrineAdd 페이지 추가
import EnshrineView from "./components/EnshrineView"; // EnshrineView 페이지 추가
import Account from './components/Account';
import Partner from './components/Partner';
import Government from './components/Government';
import Tombsmap from './components/TombsMap';
import Mysetup from './components/MySetup';
import Logout from './components/Logout';
import LogInsert from './components/LogInsert';

// 다른 페이지들 import...
//import logo from './logo.svg';
//import './App.css';

function App() {
    const [userType, setUserType] = useState("");
    //const [userData, setUserData] = useState(null);
    

    useEffect(() => {


        if (window.location.hostname === "www.bitdammemory.net") {
            // 즉시 리디렉션 (브라우저의 히스토리 스택에 기록되지 않음)
            window.location.replace("https://bitdammemory.net" + window.location.pathname);
        }

        // 세션 스토리지에서 로그인 상태 확인
        const storedUserType = sessionStorage.getItem("userType");
        if (storedUserType) {
            setUserType(storedUserType);
        }
    
    }, []);

    

    return (
        <AuthProvider>  {/* <-- 전체를 감싸야 함 */}
        <Router>
            <Header userType={userType} />
            <div className="content">
                    <Routes> {/* 기존 Switch 대신 Routes 사용 */}
                        <Route path="/" element={userType ? <Login/> : <Navigate to="/login" />} />
                        <Route path="/login" element={<Login setUserType={setUserType} />} />
                        <Route path="/enshrine" element={userType ? <Enshrine /> : <Navigate to="/login" />} />
                        <Route path="/enshrineadd" element={userType ? <EnshrineAdd /> : <Navigate to="/login" />} />
                        <Route path="/enshrineedit" element={userType ? <EnshrineEdit /> : <Navigate to="/login" />} />
                        <Route path="/enshrineview" element={userType ? <EnshrineView /> : <Navigate to="/login" />} />
                    <Route path="/account" element={userType ? <Account /> : <Navigate to="/login" />} />
                    <Route path="/partner" element={userType ? <Partner /> : <Navigate to="/login" />} />
                    <Route path="/government" element={userType ? <Government /> : <Navigate to="/login" />} />
                    <Route path="/tombsmap" element={userType ? <Tombsmap /> : <Navigate to="/login" />} />
                        <Route path="/mysetup" element={userType ? <Mysetup /> : <Navigate to="/login" />} />          
                        <Route path="/loginsert" element={userType ? <LogInsert /> : <Navigate to="/login" />} />     
                        <Route path="/logout" element={<Logout setUserType={setUserType} />} />
                    {/* 다른 페이지 Route 추가 */}
                </Routes>
            </div>
            <Footer />
            </Router>
        </AuthProvider>
    );
}

export default App;
